/**
 * Cosmetic only — never simulated on server. Client owns a pool of these and
 * spawns them in response to destroy_asteroid / ship_hit events and local
 * ship thrust. No gameplay effect, so cross-client divergence is invisible.
 */
export default class Particle {
  constructor({ position, velocity, size, lifeSpan }) {
    this.position = { x: position.x, y: position.y };
    this.velocity = { x: velocity.x, y: velocity.y };
    this.radius = size;
    this.lifeSpan = lifeSpan;
    this.inertia = 0.98;
    this.dead = false;
  }

  update(dt) {
    this.position.x += this.velocity.x * dt;
    this.position.y += this.velocity.y * dt;
    this.velocity.x *= Math.pow(this.inertia, dt);
    this.velocity.y *= Math.pow(this.inertia, dt);
    this.radius -= 0.1 * dt;
    if (this.radius < 0.1) this.radius = 0.1;
    this.lifeSpan -= dt;
    if (this.lifeSpan < 0) this.dead = true;
  }
}
